import type OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import type { AccountScopeUserSettings } from 'owa-service/lib/types/AccountScopeUserSettings';
import {
    accountScopeUserOptionsProperties,
    accountScopeViewStateConfigurationProperties,
} from 'owa-service/lib/types/AccountScopeUserSettings';

export function extractAccountScopeSettingsFromOwaUserConfiguration(
    userConfiguration: OwaUserConfiguration
): AccountScopeUserSettings {
    let accountScopeSettings: AccountScopeUserSettings = {
        UserOptions: {},
        ViewStateConfiguration: {},
    };

    const userOptions = userConfiguration.UserOptions;
    if (userOptions) {
        accountScopeUserOptionsProperties.forEach(key => {
            if (key in userOptions) {
                accountScopeSettings.UserOptions[key] = userOptions[key];
                delete userOptions[key];
            }
        });
    }

    const viewStateConfig = userConfiguration.ViewStateConfiguration;
    if (viewStateConfig) {
        accountScopeViewStateConfigurationProperties.forEach(key => {
            if (key in viewStateConfig) {
                accountScopeSettings.ViewStateConfiguration[key] = viewStateConfig[key];
                delete viewStateConfig[key];
            }
        });
    }

    return accountScopeSettings;
}
